import React from "react"
import { Link } from "gatsby"
import styled from "styled-components";
import Layout from "../components/layout"
import SEO from "../components/seo"
import Carousel from "nuka-carousel";
import Popup from "reactjs-popup"
import Media from "react-media";

import LinkButtonPrimary from "../components/buttons/LinkButtonPrimary";
import LinkhrefButtonPrimary from "../components/buttons/LinkhrefButtonPrimary";
import BackgroundSection from "../components/BackgroundSection";
import Video from "../components/Video";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "reactstrap"


import { FaPlay, FaArrowRight, FaFacebookSquare, FaInstagram, FaArrowLeft } from "react-icons/fa";

import sirim from "../images/client/sirim.png";
import lembagagetah from "../images/client/lembagagetah.png";
import bainun from "../images/bainun.png";
import sungai from "../images/SungaiBuloh.png";
import kpj from "../images/kpj.png";
import uitm from "../images/client/uitm.png";
import sultanah from "../images/HospitalSultanahAminah-color.png";
import tengku from "../images/HospitalTengkuAmpuanAfzan-color.png";

import video1 from "../images/video 1.jpg"
import video2 from "../images/video 2.jpg"
import video3 from "../images/video 3.jpg"
import videohomepage from "../images/video/videohomepage.mp4"

import combed from "../images/combed.png";
import CardSimple from "../components/CardSimple";
import lisaPro from "../images/frontpanel/lisaPro.png";
import Unisel1 from "../images/training/Unisel/Unisel8.jpg";
import specificImplant from "../images/products/specificImplant.jpg";
import metalproduct from "../images/products/metalProduct.jpg";
import poliproduct from "../images/products/poliProduct.jpg";
import digitalteeth from "../images/digitalteeth.jpg";
import { useMediaQuery } from "react-responsive";

import ISO9001 from "../images/ISO9001.jpeg"
import ISO13485 from "../images/ISO13485.jpeg"
import gmp from "../images/CAREGMP.png"
import mda from "../images/mda_logo.png";
import mdanew from "../images/MDA(new).png";
import gdplong from "../images/gdpmdlong.png";

import ProductCarousel from "../components/ProductCarousel";
import EventCarousel from "../components/EventCarousel";
import memphis from "../images/memphis.png";
import Logo3dgens from "../images/3DGENS_LOGO.png"
import VerticalSLider from "../components/VerticalSlider";



const Section = styled.section`
  padding: 60px 0;
`
const TitleSection = styled.div`
background-color: #17A99E;

  h3{
    padding: 15px 0;
    text-align: center;
    color: white;
  }
`
const Quote = styled.h3`
  color: #fff;
  text-align: center;
  display: block;
  margin: 15px auto;

  .quoteauthor{
    font-size: 20px;
    font-style: italic;
    text-align: right;
    margin: 0;
  }


  @media only screen and (max-width:600px) {
    margin: 30px 0;
    font-size: 70%;

  .quoteauthor{
    font-size: 80%;
  }
  h1{
    font-size: 80%;
  }
  h3{
    font-size: 80%;
  }
  }
`
const ContentBox = styled.div`
  height: 20vh;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 25px;
  /* background-color: #000; */
  transition: all .5s;
  h5{
    margin-top: 5px;
  }
  @media only screen and (max-width: 1024px){
    height: 300px;
  }
  @media only screen and (max-width: 800px){
    height: 200px;
  }
`

const ProductItem = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  h5{
    text-align: center;
  }
  .hoverboxclass{
    display: block;
  }
  .link{
    flex: 1 1 15%;
    margin: 10px 2.5px;
    width: 100%;
    text-decoration: none;
    color: black;
    // border: 2.5px solid #000;
    border-radius: 25px;
  }
  .link:hover{
    img{
      // border: 1px solid #235551;
    }
    h5{
      color: #17A99E;
    }
    .hoverboxclass{
      display: block;
    }
    .producttitleclass{
      background-color: transparent;
    }
    .contentboxclass{
      transform: scaleY(1.2);
    }
  }
  @media only screen and (max-width: 1024px) {
    flex-wrap: wrap;
    .link{
      width: 48%; 
    }
    h5{
      font-size: 100%;
    }
  }
  @media only screen and (max-width: 400px) {
    .link{
      flex: 1 1 45%;    
    }
  }

`
const HoverBox = styled.div`
  // display:none;
  height: 100%;
  width: 100%;
`

const ProductTitle = styled.div`
  display:flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: 15px;
  background-color: rgba(255,255,255,0.7);
  width: 100%;
  height: 100%;
  border-radius: 25px;
  h5{
    text-align: center;
    font-weight: bold;
    color: #235551;
    margin: 0;
    font-size: 30px;
  }
`
const ClientList = styled.div`
  flex-wrap: wrap;
  img{
    width: 130px;
    height: 130px;
    padding: 20px;
    /* display: block; */
    /* filter: grayscale(100%); */
    object-fit: contain;
  }
  img:hover{
    filter: none;
  }
  .slider-frame {
    height: auto!important;
  }
  /* button{
    display: block;
    margin: 0 auto;
    padding: 10px 15px;
    font-size: 24px;
    background-color: #fff;
    color: #235551;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    position: relative;
  }
  button:hover{
    color: #17a99e;
  } */
  a:hover{
    text-decoration: none;
  }
`
const VideoYT = styled.div`
  /* position: relative; */
  overflow: hidden;
  padding-top: 56.25%;

  .ytvideo{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  @media only screen and (max-width: 600px){
    iframe{
      width: 100%;
    }
  }
`
const Button1 = styled.button`
  text-align: center;
  background-color: #FB222D;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  display: block;
  margin: 0 auto;

  :hover{
    background-color: #17a99e;
    color: black;
  }
  @media only screen and (max-width:600px) {
    padding: 5px 10px;
    font-size: 80%;
  }
`
const VideoThumbnail = styled.div`
  position: relative;
  background-color: #FB222D;
  color: #fff;
  padding: 5px;
  border: none;
  border-radius: 5px;
  margin: 10px;
  width: 30%;
  .play-icon{
    height: 100px;
    width: 100px;
    position: absolute;
    left: 50%;
    margin-left: -50px;
    top: 50%;
    margin-top: -50px;
  }
  img{
    margin: 0;
    width: 100%;
    height: auto;
  }
  :hover{
    background-color: #17a99e;
    color: red;
  }
  @media only screen and (max-width:600px) {
    width: 80%;
    font-size: 80%;
  }
`

const VideoFlexBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  /* flex: 1 1 100%; */
  
`

const StyledPopup = styled(Popup)`
  &-content{
    width: 95%;
    height: fit-content;

  }
`

const Modal = styled.div`
  .content{
    width: 100%;
    height: 100%;
    padding: 10px 5px;
    transition: opacity 2000ms ease-in-out;
  }
`
const Clientlink = styled.a`
  :hover{
    img{
      width: 135px;
      height: 135px;
    }
  }
`
const ButtonCarousel = styled.button`
  padding: 4px 24px;
  margin: 0;
  /* background-color: rgba(0,0,0,0.5); */
  background-color: transparent;
  color: white;
  border: none;
  font-size: 32px;

  :hover{
    /* background-color: rgba(50,50,50,0.5) */
    color: #17a99e;
  }
`
const BannerBox = styled.div`
  width: 100%;
  height: auto; 
  /* object-fit: cover; */
  position: relative;
  @media only screen and (max-width:800px) {
    width: 100%;
  }
`
const BannerContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .titleimage{
    width: 200px;
    height: auto;
  }

  @media only screen and (max-width:600px) {
    /* top: 20%; */
    .titleimage{
    width: 100px;
  }
  }
`
const BannerContentRight = styled.div`
  position: absolute;
  top: 50%;
  left: 20%;
  transform: translate(-50%, -80%);

`
const BannerExtra = styled.div`
  .extratext{
    text-align: center;
    color: #fff;
    margin-top: 15px;
  }
  @media only screen and (max-width:600px) {
    /* bottom: 18%; */
    .extratext{
      margin-top: 5px;
      font-size: 50%;
    }
  }
`
const BannerFooterRight = styled.div`
  color: #fff;
  text-align: center;
  position: fixed;
  bottom: 10%;
  left: 65%;
  right: 0;
  @media only screen and (max-width:600px) {
    display: none;
    h3{
      font-size: 80%;
    }
}
`
const BannerFooter = styled.div`
color: #fff;
text-align: center;
position: fixed;
bottom: 10%;
left: 0;
right: 0;
@media only screen and (max-width:720px) {
  display: none;
  h3{
    font-size: 80%;
  }
.buttonRight{
  position: absolute;
  left: 65%;
}
.buttonLeft{
  position: absolute;
  right: 65%;
}
}
`
const StoriesBox = styled.div`
  margin: 0 10px;
`

const StoriesFlexBox = styled.div`
  display: flex;
  flex-wrap: nowrap;
  .flex-item{
    flex: 1 1 33%;
  }
  @media only screen and (max-width:800px) {
    flex-wrap: wrap;
    .flex-item{
      flex: 1 1 100%;
    }
  }

`

const IframeRes = styled.div`
  width: 100%;
  /* height: 0; */
  padding-bottom: 56.2%;
  position: relative;
  iframe{
    position: absolute;
    width: 100%;
    height: 100%;
  }
`
const ButtonDiv = styled.div`
  margin: 20px auto;
  text-align: center;
`

const LinkDiv = styled.div`
  margin: 20px;
`

const IsoImage = styled.div`
  flex-direction: row;
  text-align: center;
  img{
    width: 240px;
    height: 240px;
    padding: 20px;
    object-fit: contain;
  }
`

const CertificationDiv = styled.div`
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: space-around;
  background-color: #fff;
  h3{
    flex: 0 0 100%;
    text-align: center;
  }
`

const CertificateBox = styled.div`
  flex-direction: row;
  flex-flow: row;
  justify-content: center;
  text-align: center;
`
const CertifiedImg = styled.img`
  background-color: #fff;
  width: auto;
  height: 150px;
  object-fit: contain;
  padding: 10px;
  margin: 0 5px;
`

const MediaContainer = styled.div`
  width: 100%;
  height: 95vh;
  position: relative;
  .videobox{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .eventbox{
    width: 100%;
    height: fit-content;
    position: absolute;
    top: 5%;
    left: 0;
    z-index: 1;
    padding: 20px 0;
    .image{
      // flex: 1 1;
      img{
        margin-bottom: 10px;
        width: 300px;
        height: auto;
        // transform: scale(0.5);
      }
    }
    .sliderComponent{
      position: absolute;
      top: 0;
      right: 1%;
    }
    .eventdetails{
      // flex: 1 1;
      width: 100%;
      padding: 20px 0;
      border-radius: 15px;
      background-color: rgba(39, 199, 216, 0.5)
    }
  }
`

const products = [
  {
    image: specificImplant,
    title: <span>Medical</span>,
    link: "/medical"
  },
  {
    image: digitalteeth,
    title: <span>Digital Dentistry</span>,
    link: "/digital-dentistry"
  },
  {
    image: poliproduct,
    title: <span>Engineering</span>,
    link: "/engineering"
  },
  {
    image: Unisel1,
    title: <span>Training & Consultation</span>,
    link: "/training"
  },
  {
    image: metalproduct,
    title: <span>Research & Development</span>,
    link: "/research"
  },
  {
    image: lisaPro,
    title: <span>3D Printers</span>,
    link: "/printer"
  },
]

  const clients = [
    {
      link: "http://www.sirim.my/",
      image: sirim
    },
    {
      link: "http://www.lgm.gov.my/",
      image: lembagagetah
    },
    {
      link: "https://hrpb.moh.gov.my/baru/",
      image: bainun
    },
    {
      link: "http://htaa.moh.gov.my",
      image: tengku
    },
    {
      link: "http://hsajb.moh.gov.my/",
      image: sultanah
    },
    {
      link: "https://hsgbuloh.moh.gov.my/",
      image: sungai
    },
    {
      link: "https://www.kpjhealth.com.my/",
      image: kpj
    },
    {
      link: "https://uitm.edu.my/",
      image: uitm
    },
  ]

  const clientmap = clients.map((client) => (
    // <Clientlink href={client.link} target="_blank" rel="noopener noreferrer">
      <img src={client.image} alt="" ></img>
    // </Clientlink>
  ))

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 992 })
    return isDesktop ? children : null
  }
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
  }
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
  }
  const Default = ({ children }) => {
    const isNotMobile = useMediaQuery({ minWidth: 768 })
    return isNotMobile ? children : null
  }

  const videoID = [
    {
      video: "https://www.youtube.com/embed/m1rLWHqXmwA?rel=0&showinfo=1&controls=0&autoplay=1",
      thumbnail: video1,
      // thumbnail: "http://img.youtube.com/vi/m1rLWHqXmwA/0.jpg",
    },
    {
      video: "https://www.youtube.com/embed/QnRws15aUcU?rel=0&showinfo=1&controls=0&autoplay=1",
      thumbnail: video2,
      // thumbnail: "http://img.youtube.com/vi/QnRws15aUcU/0.jpg",
    },
    {
      video: "https://www.youtube.com/embed/VP8lnQGgpE4?rel=0&showinfo=1&controls=0&autoplay=1",
      thumbnail: video3,
      // thumbnail: "http://img.youtube.com/vi/VP8lnQGgpE4/0.jpg",
    },
  ]

  const certificates = [
    {
      image: gdplong,
      title: "Good Distribution Practise",
    },
    {
      image: mdanew,
      title: "Medical Device Authority",
    },
    {
      image: ISO13485,
      title: "Medical Devices",
    },
    {
      image: ISO9001,
      title: "Quality Management",
    },
    {
      image: gmp,
      title: "Care Good Manufacturing Practise"
    }
  ]

  const IndexPage = ({data}) => {

    const name = (e) => {console.log("click")}
    
    const state = { ytVideo: 'https://www.youtube.com/embed/m1rLWHqXmwA?rel=0&showinfo=1&controls=0' }

    return ( 
    <Layout>
    <SEO 
      title="3D Printing Malaysia" 
      description="3D Gens & 3D Printing Technology - with the aim to industrialize 3D printing technology in Malaysia"
    />
    <MediaContainer>
      <div className="videobox">
        <Video src={videohomepage} />
      </div>
      <Default>
        <div className="eventbox">
          <Container className="flexboxjustify">
            <div className="image">
              <img src={Logo3dgens}></img>
            </div>
            <div className="eventdetails">
              <h2 style={{textAlign: "center", marginBottom: "20px"}}>Upcoming Events</h2>
              <EventCarousel />
            </div>
          </Container>
          {/* <div className="sliderComponent">
            <VerticalSLider />
          </div> */}
        </div>
      </Default>
    </MediaContainer>
    <Mobile>
      <BackgroundSection>
        <div className="eventbox">
          <Container className="flexboxjustify">
            <div className="image">
              <img src={Logo3dgens}></img>
            </div>
            <div className="eventdetails">
              <h2 style={{textAlign: "center", marginBottom: "20px"}}>Upcoming Events</h2>
              <EventCarousel />
            </div>
          </Container>
        </div>
      </BackgroundSection>
    </Mobile>
{/* Product Section */}
      <BackgroundSection>
        <h3 style={{textAlign: "center", marginBottom: "40px"}}>Products & Services</h3>
        <ProductCarousel />
      </BackgroundSection>
{/* Quality Section */}
      <BackgroundSection image={memphis}>
        <Container>
          <h3 style={{textAlign: "center", marginBottom: "40px"}}>Quality Assurance</h3>
          <CertificationDiv>
            {certificates.map((item) => (
              <CertificateBox>
                <CertifiedImg src={item.image} />
                <h5>{item.title}</h5>
              </CertificateBox>
            ))}
          </CertificationDiv>
        </Container>
      </BackgroundSection>

{/* Event Section */}
    {/* <Container>
      <BackgroundSection>
        <h3 style={{textAlign: "center", marginBottom: "40px"}}>Upcoming Events</h3>
        <EventCarousel />
      </BackgroundSection>
    </Container>
       */}
{/* Stories Section */}
    <Section style={{ backgroundColor:"#fff"}}>
      <Container>
        <h3 style={{textAlign: "center", marginBottom: "40px"}}>Success Stories</h3>
        {data.allStrapiStories.edges.filter(stories => stories.node.show == true).length <= 3 ? (
          <StoriesFlexBox>
            {data.allStrapiStories.edges.filter( stories => stories.node.show == true ).map(story => (
                <div className="flex-item">
                  {story.node.media ? 
                    <CardSimple justifytext imageURL={story.node.media.publicURL} title={story.node.title} description={story.node.summary ? story.node.summary : story.node.description.substr(0, 600)}>
                      <Link className="storylink" to ={`/${story.node.id}`}>Read more <FaArrowRight/></Link>
                    </CardSimple>
                  :
                    <CardSimple justifytext image={<iframe className="ytvideo" width="100%" height="100%" style={{display: "block", margin: "0px auto"}} src="https://www.youtube.com/embed/1FAQHo7OvQw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>} title={story.node.title} description={story.node.summary ? story.node.summary : story.node.description}>
                      <Link className="storylink" to ={`/${story.node.id}`}>Read more <FaArrowRight/></Link>
                    </CardSimple>
                  }
                </div>
              ))
            }
          </StoriesFlexBox>
        ):(
          <Media query="(max-width: 800px)">
          {matches => matches ? (
            // mobile
            <Carousel 
            renderCenterLeftControls={({ previousSlide }) => (<ButtonCarousel onClick={previousSlide}><FaArrowLeft/></ButtonCarousel>)} 
            renderCenterRightControls={({ nextSlide }) => (<ButtonCarousel onClick={nextSlide}><FaArrowRight/></ButtonCarousel>)} 
            width="100%" 
            height="100%"
            slidesToShow={1} 
            dragging={true} 
            pauseOnHover={true}
            withoutControls={false} 
            autoplay={true} 
            wrapAround={true} 
            swiping={true}>
              {data.allStrapiStories.edges.map(document => (
                <StoriesBox>
                  <div>
                    {document.node.media ? 
                      <CardSimple justifytext imageURL={document.node.media.publicURL} title={document.node.title} description={document.node.summary ? document.node.summary : document.node.description}>
                        <Link className="storylink" to ={`/${document.node.id}`}>Read more <FaArrowRight/></Link>
                      </CardSimple>
                    :
                    <CardSimple justifytext image={<iframe className="ytvideo" width="100%" height="100%" style={{display: "block", margin: "0px auto"}} src="https://www.youtube.com/embed/1FAQHo7OvQw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>} title={document.node.title} description={document.node.summary ? document.node.summary : document.node.description}>
                        <Link className="storylink" to ={`/${document.node.id}`}>Read more <FaArrowRight/></Link>
                      </CardSimple>
                    }
                  </div>
                </StoriesBox>
              ))}
            </Carousel>
          ):(
            // desktop
            <Carousel 
            renderCenterLeftControls={({ previousSlide }) => (<ButtonCarousel onClick={previousSlide}><FaArrowLeft/></ButtonCarousel>)} 
            renderCenterRightControls={({ nextSlide }) => (<ButtonCarousel onClick={nextSlide}><FaArrowRight/></ButtonCarousel>)} 
            width="100%" 
            height="100%" 
            slidesToShow={3} 
            dragging={false} 
            pauseOnHover={true}
            withoutControls={false} 
            autoplay={true} 
            wrapAround={true} 
            swiping={true}>
              {data.allStrapiStories.edges.map(document => (
                <StoriesBox>
                  <div>
                    {document.node.media ? 
                      <CardSimple justifytext imageURL={document.node.media.publicURL} title={document.node.title} description={document.node.summary ? document.node.summary : document.node.description}>
                        <Link className="storylink" to ={`/${document.node.id}`}>Read more <FaArrowRight/></Link>
                      </CardSimple>
                    :
                    <CardSimple justifytext image={<iframe className="ytvideo" width="100%" height="100%" style={{display: "block", margin: "0px auto"}} src="https://www.youtube.com/embed/1FAQHo7OvQw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>} title={document.node.title} description={document.node.summary ? document.node.summary : document.node.description}>
                        <Link className="storylink" to ={`/${document.node.id}`}>Read more <FaArrowRight/></Link>
                      </CardSimple>
                    }
                  </div>
                </StoriesBox>
              ))}
            </Carousel>
          )}
          </Media>
        )}
        <LinkDiv>
          <LinkButtonPrimary toLink="/stories">More Stories <FaArrowRight/></LinkButtonPrimary>
        </LinkDiv>
      </Container>
    </Section>
{/* Youtube Section */}
    <Section>
      <Container>
        <h3 style={{textAlign: "center", marginBottom: "40px"}}>3DGensTV</h3>

        <VideoFlexBox>
          {videoID.map((videoYT) => ( 
            <StyledPopup contentStyle={{width: "95%", height: "fit-content"}} trigger={<VideoThumbnail><img src={videoYT.thumbnail} /><FaPlay className="play-icon" /></VideoThumbnail>} modal>
            <Modal>
              <div className="content">
                <div className="actualYoutube">
                  <IframeRes>
                    <iframe src={videoYT.video} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                  </IframeRes>
                </div>
              </div>
            </Modal>
          </StyledPopup>
          ))}
        </VideoFlexBox>
        <ButtonDiv>
          <LinkhrefButtonPrimary href="https://www.youtube.com/channel/UC4hNWz8Y5dsL-QA227KKaRQ">More Videos <FaArrowRight/></LinkhrefButtonPrimary>
        </ButtonDiv>
      </Container>
    </Section>

{/* Clients Section */}
    <Section style={{height:"400px", backgroundImage: `url(${combed})`, backgroundColor: '#D8D8D8', backgroundPosition: 'center', backgroundRepeat: 'repeat',}}>
      <Container>
        <h3 style={{color: "#000"}}>Our Clients</h3>
        <ClientList>
          <div style={{height: "200px"}}>
            <Media query="(max-width: 600px)">
              {matches => matches ? (
                <Carousel dragging={true} slideWidth="130px" slidesToShow={1} slidesToScroll={1} cellAlign="left" withoutControls={true} autoplay={true} wrapAround={true} swiping={true} >
                  {clientmap}
                </Carousel>
              ): (
                // clientmap
                <Carousel dragging={true} slideWidth="130px" slidesToShow={8} slidesToScroll={8} cellAlign="left" withoutControls={true} autoplay={false}>
                  {clientmap}
                </Carousel>
                )}
            </Media>
          </div>
              <LinkButtonPrimary toLink="/about/#client">Our Clients and Partners <FaArrowRight/></LinkButtonPrimary>
        </ClientList>
      </Container>
    </Section>
  </Layout>
)}

export default IndexPage

export const pageQuery = graphql`
                query IndexQuery  {
                  allStrapiStories(sort: {fields: [createdAt], order: DESC}) {
                    edges {
                      node {
                        id
                        title
                        description
                        summary
                        show
                        media{
                          publicURL
                        }
                        createdAt
                      }
                    }
                  }
                  allStrapiBanners{
                    edges{
                      node{
                        title
                        priority
                        delete
                        link
                        externalLink
                        image{
                          publicURL
                        }
                        imageMobile{
                          publicURL
                        }
                        actionButton
                        buttonPosition
                      }
                    }
                  }
                }
`
